import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {removeGaps} from 'biojs/Util';
import useAntibodyMetadata from 'molbio/antibody-engineering/useAntibodyMetadata';
import {getAntibodyVisibilitySettings} from 'molbio/antibody-engineering/visibilityHelpers';
import {VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';
import {ORANGE_DARK} from 'ui-library/Colors';

interface Props {
  residues: string;
  visibilityOptions: VisibilityOptions;
}

export default function AntibodyInfo({residues, visibilityOptions}: Props): JSX.Element {
  const ungappedResidues = removeGaps(residues);
  const [numberingScheme, cdrDefinition] = getAntibodyVisibilitySettings(visibilityOptions);
  const [antibodyMessage, organismInfo] = useAntibodyMetadata(
    ungappedResidues,
    numberingScheme,
    cdrDefinition
  );

  return (
    <>
      <div className={css(styles.organismInfo)}>{organismInfo}</div>
      <div className={css(styles.antibodyMessage)}>{antibodyMessage}</div>
    </>
  );
}

const styles = StyleSheet.create({
  antibodyMessage: {
    color: ORANGE_DARK,
    marginTop: 2,
  },
  organismInfo: {
    marginTop: 2,
  },
});
